<ul class="list-group list-group-flush full-size bg-{{theme.bright}} text-{{theme.brightContrast}}">
  <li class="list-group-item bright-12 non-selectable bg-{{theme.bright}} text-{{theme.brightContrast}}">This computer</li>

  <div class="list-group list-group-flush full-size non-selectable bg-{{theme.bright}} text-{{theme.brightContrast}}">
    <a *ngFor="let drive of drives" 
      href="javascript:;"
      (click)="selectDrive(drive)"
      class="non-selectable pl-4 list-group-item list-group-item-action bright-12 bg-{{theme.bright}} text-{{theme.brightContrast}}">
      {{drive.fullName}}
    </a>
  </div>
</ul>